import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/TemplatesComponent.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginComponent.vue')
  },
  {
    path: '/broadcasts',
    name: 'Broadcasts',
    component: () => import(/* webpackChunkName: "about" */ '../views/Broadcasts.vue'),
    meta: { auth: true, title: 'Broadcasts' }
  },
  {
    path: '/broadcasts/:id',
    name: 'BroadcastEditor',
    component: () => import(/* webpackChunkName: "about" */ '../components/BroadcastEditorComponent.vue'),
    meta: { auth: true, title: 'Broadcast Editor' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard', 
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
    meta: { auth: true, title: 'Ravenhub Dashbaord' }
  },
  {
    path: '/event-stream',
    name: 'EventStream', 
    component: () => import(/* webpackChunkName: "about" */ '../views/EventStream.vue'),
    meta: { auth: true, title: 'Event Stream' }
  },
  {
    path: '/event-types',
    name: 'EventTypes',
    component: () => import(/* webpackChunkName: "about" */ '../views/EventTypeComponent.vue'),
    meta: { auth: true, title: 'Event Types' }
  },
  {
    path: '/event-types/:id',
    name: 'EventTypeEditor',
    component: () => import(/* webpackChunkName: "about" */ '../components/EventTypeEditorComponent.vue'),
    meta: { auth: true, title: 'Event Type Editor' }
  },
  {
    path: '/templates',
    name: 'Templates',
    component: () => import(/* webpackChunkName: "about" */ '../views/TemplatesComponent.vue'),
    meta: { auth: true, title: 'Templates' }
  },
  {
    path: '/templates/:id',
    name: 'TemplateEditor',
    component: () => import(/* webpackChunkName: "about" */ '../components/TemplateEditorComponent.vue'),
    meta: { auth: true, title: 'Template Editor' }
  },
  {
    path: '/slack-auth',
    name: 'SlackAuth', 
    component: () => import(/* webpackChunkName: "about" */ '../components/SlackAuth.vue'),
    meta: { auth: true, title: 'Slack Auth' }
  },
  {
    path: '/settings',
    name: 'Settings', 
    component: () => import(/* webpackChunkName: "about" */ '../views/Settings.vue'),
    meta: { auth: true, title: 'Settings' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Ravenhub';
  next();
});

export default router
